<template>
  <div id="app">
    <transition name="fade" mode="out-in">
			<router-view></router-view>
			
    </transition>
  </div>
</template>
<script>
export default {
  name: 'App'
}
</script>
<style>
html, body { height: 100%; }
body, header, footer, nav, section, aside, article, dl, dt, dd, textarea, button, input, select, figure, figcaption {
		padding: 0;
		margin: 0;
		list-style: none;
		font-style: normal;
		text-decoration: none;
		border: none;
		font-weight: normal;
		/* font-family: -apple-system, BlinkMacSystemFont, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft Yahei', '微软雅黑', sans-serif; */
		/* font-family: -apple-system, BlinkMacSystemFont, 'Hiragino Sans GB', 'Microsoft Yahei', '微软雅黑', sans-serif; */
		font-family: "Pingfang SC","Microsoft YaHei",Helvetica Neue,Arial,sans-serif;
		/* font-family: '微软雅黑'; */
		box-sizing: border-box;
		-webkit-tap-highlight-color:transparent;
		-webkit-font-smoothing: antialiased;
		/* &:hover{
				outline: none;
		} */
		
}

input[type="button"], input[type="submit"], input[type="search"], input[type="reset"] {
		-webkit-appearance: none;
}
/*添加css样式*/
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
		-webkit-appearance: none;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
  height: 100%;
  width: 100%;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
